
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import CollapseItem from '@/components/collapse.vue';
import shoplist from "@/components/shoplist.vue";
import chooseCoupon from "@/components/chooseCoupon.vue"
import choosePrize from "@/components/choosePrize.vue"
import uploadImg from "@/components/upload-img.vue"
import Message from '@/components/message.vue';
import {
	activityExchangeBuyactivityExchangeBuyInfo,
	activityExchangeBuyactivityExchangeBuySave
} from "@/api/live"
@Component({
	name: '',
	components: {
		PageFooter,
		CollapseItem,
		shoplist,
		chooseCoupon,
		uploadImg,
		choosePrize,
		'slz-message': Message,
	}
})

export default class ProductList extends Vue {
	private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
	private pageloading = false
	private form: any = {
		Id: 0,
		ActivityState: 0,
		Name: '',
		StartTime: '',
		EndTime: '',
		ActivityRule: '',
		JoinObject: [1, 2],
		FullMoney: '',
		FullMoney2: '',
		ActivityRangeType: 0,//0全部商品1指定商品
		ActivityRangeType2: 0,//2参加//3不参加
		ActivityExchangeBuyProductItemList: [],
		IsWithOrderRefund: true,
		ExchangeBuyProductCountLimit: '',
		ActivityExchangeBuyExchangeProductItemList: []
	}
	private comparelist = [
		{ value: 1, label: "等于" },
		{ value: 2, label: "大于" },
		{ value: 3, label: "大于或等于" },
		{ value: 4, label: "小于" },
		{ value: 5, label: "小于或等于" },
	];
	private ActivityExchangeBuyProductItemList: any = []
	private total = 0
	private pageSize = 10
	private pageNo = 1
	private shopShow = false
	private saveShow = false
	private exchangeGoods: any = []
	private total2 = 0
	private pageSize2 = 10
	private pageNo2 = 1
	private exchangeShow = false

	private mounted() {
		if (Number(this.$route.query.Id)) {
			this.getInfo()
		}
	}



	private delrow2(row) {
		if (row.VirtualExchangeCount > 0) {
			this.$message.error('商品已存在换购数据不支持删除，若后续不允许换购建议将商品下架')
			return
		}
		this.form.ActivityExchangeBuyExchangeProductItemList = this.form.ActivityExchangeBuyExchangeProductItemList.filter((v) => {
			return v.Id != row.Id;
		});
		this.getExchangeGoods();
	}
	private getExchangeShop(list) {
		if (!list || !list.length) {
			this.$message.error("请选择商品");
			return;
		}
		let oldlist = JSON.parse(JSON.stringify(this.form.ActivityExchangeBuyExchangeProductItemList))
		this.form.ActivityExchangeBuyExchangeProductItemList = JSON.parse(JSON.stringify(list.map(v => {
			let old = oldlist.find(x => x.Id == v.Id)
			v.ProductId = v.Id
			v.MinGroupPrice = v.GroupPrice
			v.MaxGroupPrice = v.GroupPriceMax
			if (old && old.Id) {
				v.SingleExchangeBuyProductLimit = old.SingleExchangeBuyProductLimit
				v.VirtualExchangeCount = old.VirtualExchangeCount || 0
				v.RealExchangeCount = old.RealExchangeCount || 0
			} else {
				v.SingleExchangeBuyProductLimit = ''
				v.VirtualExchangeCount = 0
				v.RealExchangeCount = 0
			}
			// console.log(old)
			return v
		}))).sort((a, b) => {
			return b.Id - a.Id
		})
		// console.log(this.form.ActivityExchangeBuyExchangeProductItemList)
		this.exchangeShow = false
		this.getExchangeGoods()
	}
	private changePage2(e) {
		this.pageNo2 = e
		this.getExchangeGoods()
	}
	private getExchangeGoods() {
		this.total2 = this.form.ActivityExchangeBuyExchangeProductItemList.length;
		this.exchangeGoods = this.form.ActivityExchangeBuyExchangeProductItemList.filter((v, i) => {
			return (i >= (this.pageNo2 - 1) * this.pageSize2 && i < this.pageNo2 * this.pageSize2);
		});
		// console.log(this.exchangeGoods)
		if (this.pageNo2 > 1 && (!this.exchangeGoods || !this.exchangeGoods.length)) {
			this.pageNo2--;
			this.getExchangeGoods();
		}
	}
	private async getInfo() {
		try {
			this.pageloading = true
			let res = await activityExchangeBuyactivityExchangeBuyInfo({
				Id: this.$route.query.Id
			})
			if (res.IsSuccess) {
				let form = res.Result
				form.Id = this.$route.query.Id
				if (form.ActivityRangeType == 0) {
					form.ActivityRangeType2 = 0
				} else if (form.ActivityRangeType == 1) {
					form.FullMoney2 = form.FullMoney
					form.FullMoney = ''
					form.ActivityRangeType2 = 2
				} else {
					if (form.ActivityRangeType == 2) {
						form.ActivityRangeType2 = 2
					} else if (form.ActivityRangeType == 3) {
						form.ActivityRangeType2 = 3
					} else if (form.ActivityRangeType == 4) {
						form.ActivityRangeType2 = 3
					}
					form.FullMoney2 = form.FullMoney
					form.FullMoney = ''
					form.ActivityRangeType = 1
				}
				if (form.ActivityRangeType2 == 2 || form.ActivityRangeType2 == 3) {
					form.ActivityExchangeBuyProductItemList = form.ActivityExchangeBuyProductItemList.map(v => {
						return {
							...v,
							ImgUrlComplete: v.MainImgUrlComplete,
							Id: v.ProductId
						}
					})
				}
				form.ActivityExchangeBuyExchangeProductItemList = form.ActivityExchangeBuyExchangeProductItemList.map(v => {
					return {
						...v,
						ImgUrlComplete: v.MainImgUrlComplete,
						Id: v.ProductId,
						GroupPrice: v.MinGroupPrice,
						GroupPriceMax: v.MaxGroupPrice
					}
				})

				let date = new Date().getTime()
				let start = new Date(form.StartTime).getTime()
				let end = new Date(form.EndTime).getTime()
				if (date < start) {
					form.ActivityState = 0
				} else if (date > end) {
					form.ActivityState = 2
				} else {
					form.ActivityState = 1
				}
				// console.log(form.ActivityExchangeBuyProductItemList)
				this.form = JSON.parse(JSON.stringify(form))
				this.getActivityExchangeBuyProductItemList()
				this.getExchangeGoods()
				// console.log(this.form)
			}
		} finally {
			this.pageloading = false
		}
	}
	private async confirmSave() {
		try {
			this.pageloading = true
			let form = JSON.parse(JSON.stringify(this.form))
			if (form.ActivityRangeType == 1) {
				if (form.ActivityRangeType2 == 2) {
					form.ActivityRangeType = 2
				} else {
					form.ActivityRangeType = 4
				}
			}
			if (form.ActivityRangeType == 0) {
				form.ActivityExchangeBuyProductItemList = []
			} else {
				form.FullMoney = form.FullMoney2
				form.ActivityExchangeBuyProductItemList = form.ActivityExchangeBuyProductItemList.map(v => {
					return {
						ProductId: v.ProductId,
						MainImgUrl: v.MainImgUrl,
						MainImgUrlComplete: v.MainImgUrlComplete,
						ProductName: v.ProductName,
					}
				})
			}
			delete form.ActivityRangeType2
			delete form.FullMoney2
			let res: any = await activityExchangeBuyactivityExchangeBuySave(form)
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.pageloading = false
		}
	}
	private tosave() {
		let two = /^\d+(\.\d{1,2})?$/
		if (!this.form.Name) {
			this.$message.error('请输入活动名称')
			return
		}
		if (!this.form.StartTime || !this.form.EndTime) {
			this.$message.error('请完善活动时间')
			return
		}
		if (new Date(this.form.StartTime).getTime() > new Date(this.form.EndTime).getTime()) {
			this.$message.error('开始时间不能晚于结束时间')
			return
		}
		if (!this.form.ActivityRule) {
			this.$message.error('请填写活动规则，方便用户更好了解活动细则')
			return
		}
		if (!this.form.JoinObject || !this.form.JoinObject.length) {
			this.$message.error('请选择参与人群')
			return
		}
		console.log(this.form.ActivityRangeType)
		if (this.form.ActivityRangeType == 0 && !this.form.FullMoney) {
			this.$message.error('请输入单笔订单满足金额')
			return
		}
		if (this.form.ActivityRangeType == 1 && !this.form.FullMoney2) {
			this.$message.error('请输入单笔订单满足金额')
			return
		}
		if (this.form.ActivityRangeType == 1) {
			if (!this.form.ActivityExchangeBuyProductItemList || !this.form.ActivityExchangeBuyProductItemList.length) {
				this.$message.error("请设置指定商品");
				return;
			}
		}
		if (this.form.ExchangeBuyProductCountLimit < 0 || this.form.ExchangeBuyProductCountLimit > 9999) {
			this.$message.error('换购数量限制允许0~9999')
			return
		}
		if (!this.form.ActivityExchangeBuyExchangeProductItemList || !this.form.ActivityExchangeBuyExchangeProductItemList.length) {
			this.$message.error('请选择换购商品')
			return
		} else {
			for (let item of this.form.ActivityExchangeBuyExchangeProductItemList) {
				if (item.SingleExchangeBuyProductLimit < 0 || item.SingleExchangeBuyProductLimit > 999) {
					this.$message.error('单次换购数量限制允许输入0~999的整数')
					return
				}
			}
		}
		this.saveShow = true
	}

	private uploadSuc(file, key) {
		this.form[key] = file
	}

	private delrow(row) {
		this.form.ActivityExchangeBuyProductItemList = this.form.ActivityExchangeBuyProductItemList.filter((v) => {
			return v.Id != row.Id;
		});
		this.getActivityExchangeBuyProductItemList();
	}
	private getshop(list) {
		if (!list || !list.length) {
			this.$message.error("请选择商品");
			return;
		}
		this.form.ActivityExchangeBuyProductItemList = list.map(v => {
			v.ProductId = v.Id
			return v
		})
		this.shopShow = false;
		this.getActivityExchangeBuyProductItemList();
	}
	private changePage(e) {
		this.pageNo = e;
		this.getActivityExchangeBuyProductItemList();
	}
	private getActivityExchangeBuyProductItemList() {
		this.total = this.form.ActivityExchangeBuyProductItemList.length;
		this.ActivityExchangeBuyProductItemList = this.form.ActivityExchangeBuyProductItemList.filter((v, i) => {
			return (i >= (this.pageNo - 1) * this.pageSize && i < this.pageNo * this.pageSize);
		});
		// console.log(this.ActivityExchangeBuyProductItemList)
		if (this.pageNo > 1 && (!this.ActivityExchangeBuyProductItemList || !this.ActivityExchangeBuyProductItemList.length)) {
			this.pageNo--;
			this.getActivityExchangeBuyProductItemList();
		}
	}
	private changeApplicablegoods(e) {
		this.form.ActivityRangeType2 = this.form.ActivityRangeType2 == 0 ? 2 : this.form.ActivityRangeType2
	}
}
